export var RecentSearchTextsCount = 3;
export var SearchSuggestionCount = 2;
export var TotalSearchCategoryCount = 5;
var _onSearchDetailsView = false;
export function GetOnSearchDetailsView() {
    return _onSearchDetailsView;
}
export function SetOnsearchDetailsView(onView) {
    _onSearchDetailsView = onView;
}
//# sourceMappingURL=GlobalSearch.types.js.map